import { TooltipPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ImportacionFacturaProps } from "context/initialStates/_globals"
import { Suspense, useState } from "react"
import { useTranslation } from "react-i18next"
import { CircularProgress } from "../CircularProgress"
import { TIPO_IMPORTACION } from "../NavBar/Components/NavBarRegistred/MenuImportacionesGenerico"
import ModalVerErroresImportacionToast from "./components/ModalVerErroresImportacionToast/ModalVerErroresImportacionToast"

const ToastImportFacturatem = ({
  id,
  nombreFichero,
  message,
  numeroProcesadas,
  numeroTotal,
  type,
}: ImportacionFacturaProps) => {
  const { t } = useTranslation()
  const [show, setShow] = useState<boolean>(false)
  return (
    <section>
      <div
        key={id}
        className='tw-flex tw-flex-row tw-w-auto tw-items-center tw-justify-between tw-gap-4 tw-p-4'
      >
        <div className='tw-flex tw-items-center tw-justify-center tw-rounded tw-bg-info-10 tw-h-12 tw-w-12'>
          <FontAwesomeIcon
            icon={["fal", "file-excel"]}
            className='tw-text-info tw-h-5'
          />
        </div>
        <div className='tw-flex tw-flex-col tw-flex-1 tw-items-start'>
          {type === TIPO_IMPORTACION.SAGE && message ? (
            <span className='tw-flex tw-flex-row tw-items-center tw-text-xs tw-text-danger'>
              {t("integracion.toast.notComplet")}
            </span>
          ) : (
            <span className='tw-flex tw-flex-row tw-items-center tw-text-xs tw-gap-1'>
              {numeroProcesadas === numeroTotal
                ? t("integracion.toast.import")
                : t("integracion.toast.isImport")}

              <span>
                {numeroProcesadas}/{numeroTotal}
              </span>

              <span className='tw-inline-flex tw-items-center tw-gap-1'>
                <span>-</span>
                <span className='tw-w-fit tw-text-end'>
                  {Math.round((numeroProcesadas / numeroTotal) * 100)}%
                </span>
              </span>

              {t("integracion.toast.percComplet")}
            </span>
          )}
          <span className='tw-text-sm tw-font-medium tw-text-nowrap tw-mt-1'>
            {nombreFichero}
          </span>
        </div>

        <span>
          {message?.length ? (
            <>
              <TooltipPrimeReact
                id={`.importacionesTooltip${id}`}
                target={`.importacionesTooltip${id}`}
                content='Mostrar errores'
                position='right'
                pt={{
                  text: {
                    className: "tw-max-w-60 tw-break-words",
                  },
                }}
              />
              <span
                onClick={() => setShow(!show)}
                className={`importacionesTooltip${id} tw-flex tw-cursor-pointer tw-justify-center tw-items-center tw-rounded-full tw-h-6 tw-w-6 tw-bg-danger-10`}
              >
                <FontAwesomeIcon
                  icon={["fal", "exclamation-triangle"]}
                  className='tw-text-danger tw-w-fit tw-h-3'
                />
              </span>
            </>
          ) : numeroProcesadas === numeroTotal ? (
            <span className='tw-flex tw-justify-center tw-items-center tw-rounded-full tw-h-6 tw-w-6 tw-bg-gradient-to-r tw-from-degradado-start tw-to-degradado-end'>
              <FontAwesomeIcon
                icon={["fal", "check"]}
                className='tw-text-white tw-h-3'
              />
            </span>
          ) : (
            Boolean(numeroProcesadas && numeroTotal) && (
              <CircularProgress
                percent={(numeroProcesadas / numeroTotal) * 100}
                linearGradient={["#4CC8EA", "#1FC567"]}
                round
                colorCircle='#e6e6e6'
              />
            )
          )}
        </span>
      </div>
      <Suspense>
        <ModalVerErroresImportacionToast
          show={show}
          onHide={() => setShow(!show)}
          message={message}
          title={nombreFichero}
        />
      </Suspense>
    </section>
  )
}

export default ToastImportFacturatem
